/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TaskType
 */
export interface TaskType {
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    taskTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    taskTypeNameEn?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    deprecated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    featureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    nameKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    descriptionKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    referenceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    releaseDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    isMedicalComponent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    refIcon: string;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    hashIcon: string;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    $type?: TaskTypeTypeEnum;
}


/**
 * @export
 */
export const TaskTypeTypeEnum = {
    PtwPtw100AppZeroCoreSharedLicenseComponentModelsTaskTypePtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.TaskType, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type TaskTypeTypeEnum = typeof TaskTypeTypeEnum[keyof typeof TaskTypeTypeEnum];


/**
 * Check if a given object implements the TaskType interface.
 */
export function instanceOfTaskType(value?: unknown): value is TaskType {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskTypeTypeEnum)[0];
}

export function TaskTypeFromJSON(json: any): TaskType {
    return TaskTypeFromJSONTyped(json, false);
}

export function TaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskTypeId': !exists(json, 'taskTypeId') ? undefined : json['taskTypeId'],
        'taskTypeNameEn': !exists(json, 'taskTypeNameEn') ? undefined : json['taskTypeNameEn'],
        'deprecated': !exists(json, 'deprecated') ? undefined : json['deprecated'],
        'featureId': !exists(json, 'featureId') ? undefined : json['featureId'],
        'nameKey': !exists(json, 'nameKey') ? undefined : json['nameKey'],
        'descriptionKey': !exists(json, 'descriptionKey') ? undefined : json['descriptionKey'],
        'referenceNumber': !exists(json, 'referenceNumber') ? undefined : json['referenceNumber'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'releaseDate': !exists(json, 'releaseDate') ? undefined : json['releaseDate'],
        'isMedicalComponent': !exists(json, 'isMedicalComponent') ? undefined : json['isMedicalComponent'],
        'refIcon': json['refIcon'],
        'hashIcon': json['hashIcon'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TaskTypeToJSON(value?: TaskType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskTypeId': value.taskTypeId,
        'taskTypeNameEn': value.taskTypeNameEn,
        'deprecated': value.deprecated,
        'featureId': value.featureId,
        'nameKey': value.nameKey,
        'descriptionKey': value.descriptionKey,
        'referenceNumber': value.referenceNumber,
        'version': value.version,
        'releaseDate': value.releaseDate,
        'isMedicalComponent': value.isMedicalComponent,
        'refIcon': value.refIcon,
        'hashIcon': value.hashIcon,
        '$type': value.$type,
    });
}

